import { render } from "./VerifyOTP.vue?vue&type=template&id=91654fca"
import script from "./VerifyOTP.vue?vue&type=script&lang=js"
export * from "./VerifyOTP.vue?vue&type=script&lang=js"

import "./VerifyOTP.vue?vue&type=style&index=0&id=91654fca&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__